<template>
  <div class="careers-page">
    <section class="products-header">
      <div class="container">
        <h1 class="page-title">
          <span class="title-glow">加入我们</span>
        </h1>
        <p class="page-subtitle">与优秀的伙伴一起，面向未来创造价值</p>
      </div>
    </section>

    <section class="jobs-section">
      <div class="container">
        <div class="jobs-grid">
          <div 
            v-for="(job, index) in paginatedJobs" 
            :key="job.id"
            class="job-card animate-zoom-in" 
            :style="{ animationDelay: `${(index + 1) * 0.1}s` }"
            @click="handleJobCardClick(job)"
          >
            <h3 class="job-title">{{ job.title }}</h3>
            <p class="job-meta">地点：{{ job.location }} · {{ job.type }}</p>
            <ul class="job-req">
              <li
                v-for="(req, reqIndex) in (job.requirements || []).slice(0, 4)"
                :key="reqIndex"
              >
                {{ req }}
              </li>
              <li
                v-if="job.requirements && job.requirements.length > 4"
                class="job-req-more"
              >
                ……
              </li>
            </ul>
            <div class="job-more">点击查看详情 &gt;</div>
          </div>
        </div>
        
        <!-- Element Plus 分页器 -->
        <div class="pagination-wrapper">
          <el-pagination
            v-model:current-page="currentPage"
            v-model:page-size="pageSize"
            :page-sizes="[6, 9, 12, 15]"
            :total="totalJobs"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
        
        <!-- <p class="careers-note animate-fade-in-up" style="animation-delay: .4s">
          若未看到合适岗位，欢迎自荐至 <a href="mailto:wuyh@3clouds.cn">wuyh@3clouds.cn</a>。
        </p> -->
      </div>
    </section>
  </div>
  </template>

<script>
import axios from 'axios'

export default {
  name: 'Careers',
  data() {
    return {
      jobs: [],
      allJobs: [],
      loading: false,
      error: null,
      currentPage: 1,
      pageSize: 6,
      zhipinLink: ''
    }
  },
  computed: {
    totalJobs() {
      return this.allJobs.length
    },
    paginatedJobs() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.allJobs.slice(start, end)
    }
  },
  mounted() {
    this.fetchJobs()
  },
  methods: {
    async fetchJobs() {
      try {
        this.loading = true
        this.error = null
        const response = await axios.get('/api/about/careerstable')
        if (response.data.code === 200) {
          this.allJobs = response.data.data.jobs || []
          this.jobs = this.allJobs
          this.zhipinLink = response.data.data.zhipinLink || ''
        } else {
          this.error = response.data.message || '获取招聘岗位列表失败'
          this.allJobs = []
          this.jobs = []
        }
      } catch (error) {
        console.error('获取招聘岗位列表失败:', error)
        this.error = '网络请求失败，请检查服务器是否运行'
        this.allJobs = []
        this.jobs = []
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      // 滚动到顶部
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      // 滚动到顶部
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    handleJobCardClick(job) {
      // 跳转到站内岗位详情页，携带岗位 ID（参考新闻详情的跳转方式）
      if (job && job.id != null) {
        this.$router.push({
          path: '/about/careers/detail',
          query: { id: job.id }
        })
      } else {
        console.warn('岗位缺少ID，无法跳转到详情页', job)
      }
    }
  }
}
</script>

<style scoped>
.careers-page {
  /* min-height: 100vh; */
  /* padding-top: 70px; */
  /* background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */
  background-color: white;
}

.products-header {
  position: relative;
  background-image: url('@/assets/background_header/加入我们详情页.png');
  background-size: cover;
  background-position: center;
  padding: 45px 0;
  overflow: hidden;
  min-height: 200px;
  display: flex;
  align-items: center;
}

.products-header .container {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 0;
  padding: 0 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
}

.title-glow {
  display: inline-block;
  font-size: 46px;
  font-weight: 900;
  letter-spacing: 5px;
  color: #ffffff;
  font-family: 'Arial Black', 'Microsoft YaHei', sans-serif;
  filter: drop-shadow(0 0 10px rgba(96, 165, 250, 0.6));
  backdrop-filter: blur(5px);
}

.page-subtitle{
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
  line-height: 1.8;
  margin-left: 2em;
  backdrop-filter: blur(5px);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 20px;
}

.jobs-section {
  background: white;
  padding: 10px 0 30px;
}

.jobs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.job-card {
  background: white;
  border-radius: 14px;
  border: 2px solid #e7eefc;
  box-shadow: 0 8px 24px rgba(30, 85, 162, 0.08);
  padding: 22px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  cursor: pointer;
}

.job-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 34px rgba(30, 85, 162, 0.16);
}

.job-title {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 700;
  color: #1e55a2;
}

.job-meta {
  margin: 0 0 12px 0;
  color: #666;
  font-size: 14px;
}

.job-req {
  margin: 0 0 16px 16px;
  color: #333;
  line-height: 1.8;
  padding: 0;
}

.job-req li {
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.job-req-more {
  color: #999;
  font-size: 13px;
}

.job-more {
  font-size: 13px;
  color: #4c95e3;
  text-align: right;
}

.job-apply {
  display: inline-block;
  padding: 10px 16px;
  background: linear-gradient(135deg, #4c95e3 0%, #1e55a2 100%);
  color: #fff;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: opacity 0.2s ease;
}

.job-apply:hover {
  opacity: 0.9;
}

.careers-note {
  margin-top: 16px;
  color: #555;
}

.pagination-wrapper {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

/* Reuse simple animations */
.animate-zoom-in {
  opacity: 0;
  transform: scale(0.9);
  will-change: transform, opacity;
}

.animate-zoom-in.is-visible {
  animation: zoom-in 0.8s ease-out forwards;
}

/* override header title/subtitle to align with产品中心风格 */
.title-glow {
  color: #ffffff;
  filter: drop-shadow(0 0 10px rgba(96, 165, 250, 0.6));
  backdrop-filter: blur(5px);
}

.page-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
  line-height: 1.8;
  margin-left: 2em;
  backdrop-filter: blur(5px);
}

.animate-fade-in-up {
  opacity: 0;
  transform: translateY(30px);
  will-change: transform, opacity;
}

.animate-fade-in-up.is-visible {
  animation: fade-in-up 0.8s ease-out forwards;
}

@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes zoom-in {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>


